// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container__btn{width:60%}.input__search:hover .icon__close{color:#27846d!important}@media (max-width:600px){.container__btn{width:1000%}}", ""]);
// Exports
module.exports = exports;
